import {Component, inject} from '@angular/core';
import {EditorialsIconComponent} from "../../../components/icons/editorials-icon/editorials-icon.component";
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {UsersIconComponent} from "../../../components/icons/users-icon/users-icon.component";
import {IconDirective, ProfileIconComponent} from "@icons";
import {map, tap} from "rxjs/operators";
import {UserStateService} from "./user-service";
import {watchParam} from "@utils";
import {rxResource} from "@angular/core/rxjs-interop";
import {UserService} from "@api-services";
import {ButtonComponent} from "@components";

@Component({
  selector: 'wun-users',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    UsersIconComponent,
    IconDirective,
    ProfileIconComponent,
    ButtonComponent
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {
  public readonly userStateService = inject(UserStateService);
  private readonly userService = inject(UserService)
  public readonly id = watchParam('id')

  public readonly user = rxResource({
    params: () => this.id(),
    stream: (p) => this.userService.usersGetById({
      id: Number(p.params),
      includes: '["cover","defaultAddress"]'
    }).pipe(tap(d => this.userStateService.currentUser.set(d.data)))
  })
}
